// extracted by mini-css-extract-plugin
export default {"container":"CustomerInvoicesPayment_container__uoLX6"};